<template>
  <v-container class="pb-0">
    <v-row class="d-flex justify-center">
      <v-col cols="12" sm="12" md="12" lg="12" xl="9" xxl="7">
        <v-row class="pa-0 my-0">
          <v-col
            v-for="(Item, index) in itemsCombined"
            :key="index"
            :class="Item.class"
            :cols="Item.xs"
            :sm="Item.sm"
            :md="Item.md"
            class="pa-0"
          >
            <v-container class="pl-2">
              <!-- <span> -->
              <span v-for="(subItem, index) in Item.FooterItems" :key="index">
                <v-row class="pb-3 pt-0" style="font-size: 1rem">
                  <strong v-if="subItem.Title">
                    {{ subItem.Title }}
                  </strong>
                </v-row>

                <!--contact------------------------------------>
                <span v-for="(Gegevens, index) in subItem.Items1" :key="index">
                  <v-row v-if="Gegevens.Bedrijfnaam" class="pa-0">
                    <v-col cols="6" sm="12" class="d-flex flex-column pa-0">
                      <a
                        :href="Gegevens.GoogleAdres"
                        target="_blank"
                        class="text-none footerlinks text-decoration-none"
                      >
                        <p class="pb-1">{{ Gegevens.BedrijfAdres }}</p>
                        <p>{{ Gegevens.BedrijfPostCodePlaats }}</p>
                      </a>
                    </v-col>
                    <v-col
                      cols="6"
                      sm="12"
                      class="d-flex flex-column px-0 pt-0 pb-4"
                    >
                      <span v-if="Gegevens.BedrijfMail">
                        <a
                          :href="'mailto:' + Gegevens.BedrijfMail"
                          class="text-none footerlinks text-decoration-none"
                        >
                          <p class="pb-0">
                            <SvgIconPublic
                              class="footerlinksicon mr-1"
                              :sizeIcon="20"
                              :url="siteSettings.IconMail"
                            />
                            <span class="pl-2"></span>
                            {{ Gegevens.BedrijfMail }}
                          </p>
                        </a>
                      </span>

                      <span v-if="Gegevens.BedrijfTelefoonnummer">
                        <a
                          footerlinks
                          :href="'tel:' + Gegevens.BedrijfTelefoonnummer"
                          class="text-none footerlinks text-decoration-none"
                        >
                          <p class="pb-0">
                            <SvgIconPublic
                              class="footerlinksicon mr-1"
                              :sizeIcon="20"
                              :url="siteSettings.IconTelephone"
                            />
                            <span class="pl-2"></span>
                            {{ Gegevens.BedrijfTelefoonnummer }}
                          </p>
                        </a>
                      </span>
                    </v-col>

                    <v-col
                      cols="12"
                      class="pa-0 d-flex flex-column footertable pb-4"
                    >
                      <table density="compact">
                        <thead>
                          <tr style="width: 87px">
                            <th class="text-left">
                              {{ Gegevens.KvkTitle }}
                            </th>
                            <td class="text-left">{{ Gegevens.KvkNummer }}</td>
                          </tr>
                          <tr>
                            <th class="text-left" style="width: 90px">
                              {{ Gegevens.BtwTitle }}
                            </th>
                            <td class="text-left">{{ Gegevens.BtwNummer }}</td>
                          </tr>
                        </thead>
                      </table>
                    </v-col>
                  </v-row>
                </span>
                <!--FooterPage------------------------------------>
                <span
                  v-for="(Gegevens, index1) in subItem.Items2"
                  :key="index1"
                >
                  <v-row v-if="Gegevens.FooterLinkTitle">
                    <NuxtLink
                      :title="Gegevens.FooterLinkTitle"
                      :to="$methods.localePath(usePageOverviewStore().getPageUrlByPageCode(Gegevens.FooterLinkCode))"
                      class="text-none footerlinks text-decoration-none"
                    >
                      <p>{{ Gegevens.FooterLinkTitle }}</p>
                    </NuxtLink>
                  </v-row>
                </span>


                <!--OpeningTime------------------------------------>
                <div v-if="subItem.Items3 && siteSettings.FooterOpeningTimeTitle.length > 1" class="px-0 mx-0">

                    <v-row
                      class="px-0"
                      v-if="
                        siteSettings.OpeningTime[1] &&
                        siteSettings.OpeningTime[1].TimeOpen ==
                          siteSettings.OpeningTime[2].TimeOpen &&
                        siteSettings.OpeningTime[1].TimeOpen ==
                          siteSettings.OpeningTime[3].TimeOpen &&
                        siteSettings.OpeningTime[1].TimeOpen ==
                          siteSettings.OpeningTime[4].TimeOpen &&
                        siteSettings.OpeningTime[1].TimeOpen ==
                          siteSettings.OpeningTime[5].TimeOpen &&
                        siteSettings.OpeningTime[1].TimeClosed ==
                          siteSettings.OpeningTime[2].TimeClosed &&
                        siteSettings.OpeningTime[1].TimeClosed ==
                          siteSettings.OpeningTime[3].TimeClosed &&
                        siteSettings.OpeningTime[1].TimeClosed ==
                          siteSettings.OpeningTime[4].TimeClosed &&
                        siteSettings.OpeningTime[1].TimeClosed ==
                          siteSettings.OpeningTime[5].TimeClosed
                      "
                    >
                      <v-col cols="12" class="pa-0">
                        <p class="text-left pb-0">
                          {{ siteSettings.OpeningTime[1].DayName }} -
                          {{ siteSettings.OpeningTime[5].DayName }}
                        </p></v-col
                      >
                      <v-col cols="12" class="px-0 pt-1">
                        <p>
                          {{ siteSettings.OpeningTime[1].TimeOpen }} -
                          {{ siteSettings.OpeningTime[1].TimeClosed }}
                        </p></v-col
                      >
                    </v-row>

                    <v-row v-else>
                      <table class="openingsTimeTableFooter">

                        <tbody v-for="(Gegevens, index) in siteSettings.OpeningTime" :key="index">
                          <tr v-if="Gegevens.HolidayName">
                            <td class="text-left" >
                              {{ Gegevens.DayName }}
                            </td>
                            <td colspan="3" class="text-left">
                              {{ Gegevens.HolidayName }}
                            </td>
                          </tr>
                          <tr  v-else-if="Gegevens.Closed">
                            <td class="text-left">
                              {{ Gegevens.DayName }}
                            </td>
                            <td colspan="3" class="text-left" >
                              {{ Gegevens.Closed }}
                            </td>
                          </tr>
                          <tr  v-else :class="{ 'current-day': isCurrentDay(index) }">
                              <td class="text-left" >
                                {{ Gegevens.DayName }}
                              </td>
                              <td  class="text-left">
                                {{ Gegevens.TimeOpen }}
                              </td>
                              <td style='width:30px;' class="text-left"> - </td>
                              <td >
                                {{ Gegevens.TimeClosed }}
                              </td>
                          </tr>
                        </tbody>

                      </table>

                    </v-row>

                </div>

                <!--StokvisCompanyLogo------------------------------------>
                <v-row v-if="subItem.StokvisGroupLogo || subItem.LogoWebshopAuthority" :class="paddingTopLogo">
                  <v-row :justify="getJustifyLogo" v-if="subItem.StokvisGroupLogo">
                    <a
                      :href="subItem.StokvisGroupLogoLink"
                      target="_blank"
                      class="text-none text-lighttext text-decoration-none"
                    >
                      <img
                        contain
                        :alt="subItem.StokvisGroupLogoAlt"
                        :height="getHeightLogo"
                        :width="getWidthLogo"
                        :src="subItem.StokvisGroupLogo"
                      />
                    </a>
                  </v-row>
                  <v-row :justify="getJustifyLogo" v-if="subItem.LogoWebshopAuthority">
                    <a
                      :href="subItem.LogoWebshopAuthorityLink"
                      target="_blank"
                      class="text-none text-lighttext text-decoration-none"
                    >
                      <img
                        contain
                        :alt="subItem.LogoWebshopAuthorityAlt"
                        :height="getHeightLogo/2"
                        :width="getWidthLogo/2"
                        :src="subItem.LogoWebshopAuthority"
                      />
                    </a>
                  </v-row>
                </v-row>
                <!--FooterEkstralogo------------------------------------>
                <v-row v-if="subItem.StokvisGroupLogo2">
                  <v-container fluid class="py-0">
                    <v-row :justify="getJustifyShop">
                      <v-col cols="auto">
                        <v-sheet
                          class="d-flex align-center"
                          :height="getHeight"
                        >
                          <v-img
                            :src="subItem.Logo"
                            :alt="subItem.Alt"
                            width="80"
                          ></v-img>
                        </v-sheet>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-row>
              </span>
            </v-container>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row> </v-row>
  </v-container>
</template>
<style scoped>
  .openingsTimeTableFooter, .openingsTimeTableFooter td{
    border:0px;
  }
 .current-day {
  font-weight: bold;
}
</style>
<script setup>
import SvgIconPublic from "@/components/Base/SvgIconPublic.vue";
const { $methods } = useNuxtApp()
const siteSettings = useSiteSettingsStore();
const pageNames = usePageOverviewStore().pageCodeUrlMapping;
const contactPage = computed(() => {
  const pageOverviewStore = usePageOverviewStore();
  return pageOverviewStore.getPageByType("ML") || pageOverviewStore.getPageByType("MD");
});

const { PUBLIC_DATA_URL } = useRuntimeConfig().public
const isDev = process.env.NODE_ENV !== 'production'

const itemsCombined = computed(() => {
  return [
    {
      id: 1,
      xs: 12,
      sm: 4,
      md: 3,
      class: "order-1",
      FooterItems: [
        {
          Title: siteSettings.FooterContactTitle,
          Items1: [
            {
              Bedrijfnaam: siteSettings.FooterLocationName,
              BedrijfAdres: siteSettings.FooterStreetHouseNumber,
              BedrijfPostCodePlaats: siteSettings.FooterZipcodeCity,
              Land: siteSettings.FooterCountry,
              GoogleAdres: siteSettings.FooterGoogleUrl,
              BedrijfMail: siteSettings.FooterEmail,
              MailIcon: "EmailAdd",
              BedrijfTelefoonnummer: siteSettings.FooterTelephone,
              TelefoonNummerIcon: "Mobile",
              BtwTitle: siteSettings.FooterVatTitle,
              BtwNummer: siteSettings.FooterVatCode,
              KvkTitle: siteSettings.FooterCocTitle,
              KvkNummer: siteSettings.FooterCocCode,
            },
          ],
        },
      ],
    },
    {
      id: 2,
      xs: 6,
      sm: 4,
      md: 3,
      class: "order-2",
      FooterItems: [
        {
          Title: siteSettings.FooterPagesTitle,
          Items2: siteSettings.FooterPages,
          Link: siteSettings.FooterPagesCode,
        },
      ],
    },
    {
      id: 3,
      xs: 6,
      sm: 4,
      md: 3,
      class: "order-3 ",
      FooterItems: [
        {
          Title: siteSettings.FooterOpeningTimeTitle,

          Items3: siteSettings.OpeningTime,
        },
      ],
    },
    {
      id: 5,
      xs: 12,
      sm: 12,
      md: 3,
      class: "order-4",
      FooterItems: [
        {
          StokvisGroupLogo: isDev ? siteSettings.FooterLogoStokvis.replaceAll("/PUBLIC", PUBLIC_DATA_URL) : siteSettings.FooterLogoStokvis,
          StokvisGroupLogoLink: siteSettings.FooterLogoStokvisUrl,
          StokvisGroupLogoAlt: siteSettings.FooterLogoStokvisAltText,
          CopyrightItem: siteSettings.FooterCopyright,

          LogoWebshopAuthority: isDev && siteSettings.LogoWebshopAuthority ? siteSettings.LogoWebshopAuthority.replaceAll("/PUBLIC", PUBLIC_DATA_URL) : siteSettings.LogoWebshopAuthority,
          LogoWebshopAuthorityAlt: siteSettings.LogoWebshopAuthorityAltText,
          LogoWebshopAuthorityLink: siteSettings.LogoWebshopAuthorityURL
        },
      ],
    },

    {
      id: 5,
      xs: 12,
      sm: 12,
      md: 12,
      class: "order-6 order-sm-5",
      FooterItems: [
        {
          CopyrightItem: siteSettings.FooterCopyright,
        },
      ],
    },
  ];
});

const visibleFields = computed(() => {
  return fields.filter((field) => field.visible);
});

const getJustifyLogo = computed(() => {
  switch (useNuxtApp().$vuetify.display.mobile._object.name) {
    case "xs":
      return "center";
    case "sm":
      return "center";
    case "md":
      return "end";
    case "lg":
      return "end";
    case "xl":
      return "end";
    case "xxl":
      return "end";
    default:
      return "end";
  }
});

const getJustifyShop = computed(() => {
  switch (useNuxtApp().$vuetify.display.mobile._object.name) {
    case "xs":
      return "center";
    case "sm":
      return "end";
    case "md":
      return "end";
    case "lg":
      return "end";
      case "xl":
      return "end";
    case "xxl":
      return "end";
    default:
      return "end";
  }
});

const getHeightLogo = computed(() => {
  switch (useNuxtApp().$vuetify.display.mobile._object.name) {
    case "xs":
      return 64;
    case "sm":
      return 72;
    case "md":
      return 56;
    case "lg":
      return 72;
    case "xl":
      return 80;
    case "xxl":
      return 80;
    default:
      return 80;
  }
});
const getWidthLogo = computed(() => {
  switch (useNuxtApp().$vuetify.display.mobile._object.name) {
    case "xs":
      return 225;
    case "sm":
      return 243;
    case "md":
      return 200;
    case "lg":
      return 243;
    case "xl":
      return 270;
    case "xxl":
      return 270;
    default:
      return 270;
  }
});

const getHeight = computed(() => {
  switch (useNuxtApp().$vuetify.display.mobile._object.name) {
    case "xs":
      return 38;
    case "sm":
      return 38;
    case "md":
      return 85;
    case "lg":
      return 85;
    case "xl":
      return 85;
    case "xxl":
      return 85;
    default:
      return 85;
  }
});

const paddingTopLogo = computed(() => {
  switch (useNuxtApp().$vuetify.display.mobile._object.name) {
    case "xs":
      return "pt-10";
    case "sm":
      return "pt-0";
    case "md":
      return "pt-0";
    case "lg":
      return "pt-0";
    case "xl":
      return "pt-0";
    case "xxl":
      return "pt-0";
    default:
      return "pt-0";
  }
});
function isCurrentDay(index) {
      const today = new Date().getDay()
      return index === today;
}

</script>
